/* -- mui -- */
import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  liItem: {
    marginLeft: 10,
    width: '100%',
  },
}));
